// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"35203610","141":"81841d77","239":"ec48767d","455":"7e885abf","589":"939d02ee","899":"9466a1e6","977":"0a9adf46"}[chunkId] + ".chunk.js";
};